export default __webpack_public_path__ + "static/media/typeperson.34c75380.svg";